"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCssClassListEn_1 = require("./CfgCssClassListEn");
var CfgCssClassListRu_1 = require("./CfgCssClassListRu");
var CfgCssClassListLangFactory = /** @class */ (function () {
    function CfgCssClassListLangFactory() {
    }
    CfgCssClassListLangFactory.getLangInstance = function (Lang) {
        if (Lang == "RU") {
            return CfgCssClassListRu_1.CfgCssClassListRu.getLangData();
        }
        return CfgCssClassListEn_1.CfgCssClassListEn.getLangData();
    };
    return CfgCssClassListLangFactory;
}());
exports.CfgCssClassListLangFactory = CfgCssClassListLangFactory;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ui/lang/CfgCssClassListBase.ts
// module id = 2360
// module chunks = 0